import styled from 'styled-components';

export const CollapsableSectionGroup = styled.div`
  margin: 0 -0.8em;
`;
